function isMenuWindow() {
  return window.top === window && !!window.tabsController;
}

function isLoginScreen() {
  return window.LOGIN_OK === undefined;
}
class NavigationLocker {
  #isLocked = true;

  get isLocked(): boolean {
    return window.top === window
      ? this.#isLocked
      : (window.top?.navigationLocker.isLocked as boolean);
  }

  constructor() {
    window.onbeforeunload = () => {
      return (this.#isLocked && isLoginScreen() && isMenuWindow()) || undefined;
    };
  }

  unlock() {
    this.#isLocked = false;
  }
}

const navigationLocker = new NavigationLocker();

window.navigationLocker = navigationLocker;

export default navigationLocker;
